var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 165,
    height: 30,
    viewBox: "0 0 165 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 0C6.71573 0 0 6.71573 0 15C0 23.2843 6.71573 30 15 30H115C123.284 30 130 23.2843 130 15C130 6.71573 123.284 0 115 0H15ZM150 0C158.284 0 165 6.71573 165 15C165 23.2843 158.284 30 150 30C141.716 30 135 23.2843 135 15C135 6.71573 141.716 0 150 0Z",
    fill: "#E5F2F2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTag);
export default __webpack_public_path__ + "static/media/tag.56540724b83fba383d00c55a9fad9319.svg";
export { ForwardRef as ReactComponent };